import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  appointmentTypeId: number;
  datetime: Date;
  address: string;
  carLocationInstructions: string;
};

export type CreateJooserAppointment = { url: string };

export const useCreateJooserAppointment = createMutation<
  CreateJooserAppointment,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/jooser/appointment`,
      method: 'POST',
      data: {
        appointment_type_id: variables.appointmentTypeId,
        datetime: variables.datetime,
        address: variables.address,
        car_location_instructions: variables.carLocationInstructions,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
